const PITCH_CATEGORIES: { terms: string[]; weight: number }[] = [
    {
        terms: [
            "pitch deck", "investor deck", "investment deck",
            "pitch presentation", "deck for investors", "investor presentation",
        ],
        weight: 3,
    },
    {
        terms: [
            "fundraising", "fund raising", "raise funding", "raise money",
            "raise capital", "seed round", "series a", "series b", "series c",
            "pre-seed", "preseed", "venture capital", "vc funding",
            "angel investor", "angel round", "funding round",
        ],
        weight: 3,
    },
    {
        terms: [
            "investors", "angel investors", "limited partners", "vc",
        ],
        weight: 2,
    },
    {
        terms: [
            "startup", "early stage", "seed stage", "valuation", "equity",
            "pitch", "pitching",
        ],
        weight: 1,
    },
]

const THRESHOLD = 3

export function detectPitchIntent(prompt: string): boolean {
    const normalized = prompt.toLowerCase()
    let score = 0

    for (const category of PITCH_CATEGORIES) {
        if (category.terms.some((term) => normalized.includes(term))) {
            score += category.weight
        }
    }

    return score >= THRESHOLD
}
